import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import {Formik} from 'formik';
import Input from "../../Magpie/Input";

const CardSocialUpdateModel = ({isShow,hideFunc,title,submitFunction,oData, btnLoad}) => {

    return (
        <Modal className="fade bd-example-modal-lg"  backdrop="static"  show={isShow} size="lg" onHide={hideFunc}>
            <Modal.Header>
                <Modal.Title><i className="fa fa-user me-2" /> {title}</Modal.Title>
                <Button variant="" className="btn-close" onClick={hideFunc}></Button>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={{
                        linkedIn: oData.linkedin === null ? '' : oData.linkedin,
                        youtube: oData.youtube === null ? '' : oData.youtube,
                        facebook: oData.facebook === null ? '' : oData.facebook,
                        twitter: oData.twitter === null ? '' : oData.twitter,
                    }}
                    enableReinitialize={true}
                    onSubmit={(values, { setSubmitting }) => {
                        setTimeout(() => {
                            submitFunction(values)
                            setSubmitting(false);
                        }, 400);
                    }}

                >
                    {({ values,errors,handleChange,handleBlur,handleSubmit,isSubmitting }) => (
                        <form className="dz-form dzForm style-1 contact-bx" noValidate onSubmit={handleSubmit}>
                            <div className="row ">
                                <div className="col-md-6">
                                    <Input
                                        name="linkedIn"
                                        id="linkedIn"
                                        placeholder="LinkedIn"
                                        errors={errors.linkedIn}
                                        value={values.linkedIn}
                                        handleChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <Input
                                        name="youtube"
                                        id="youtube"
                                        placeholder="YouTube"
                                        errors={errors.youtube}
                                        value={values.youtube}
                                        handleChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="row ">
                                <div className="col-md-6">
                                    <Input
                                        name="facebook"
                                        id="facebook"
                                        placeholder="Facebook"
                                        errors={errors.facebook}
                                        value={values.facebook}
                                        handleChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <Input
                                        name="twitter"
                                        id="twitter"
                                        placeholder="Twitter"
                                        errors={errors.twitter}
                                        value={values.twitter}
                                        handleChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="row ">
                                <div className="mb-3"></div>
                                <Modal.Footer>
                                    <Button
                                        variant="danger light"
                                        onClick={hideFunc}
                                    >
                                        Close
                                    </Button>
                                    {
                                        !btnLoad ?
                                            <Button
                                                variant=""
                                                type="submit"
                                                className="btn btn-primary"
                                            >
                                                Save changes
                                            </Button>
                                            :
                                            <h1 className="la la-circle-o-notch la-spin me-2 text-primary " style={{fontSize:'40px'}} ></h1>
                                    }
                                </Modal.Footer>
                            </div>
                        </form>
                    )}
                </Formik>
            </Modal.Body>

        </Modal>
    )

}

export default CardSocialUpdateModel
